(function() {
  function init() {
    var root = document.querySelector('[data-filter-root]');
    var grid = document.querySelector('[data-filter-grid]');
    var emptyMsg = document.querySelector('[data-filter-empty]');

    if (!root || !grid) return;

    // Guard against duplicate listener binding
    if (root.dataset.journalFilterBound === 'true') return;
    root.dataset.journalFilterBound = 'true';

    var chips = Array.from(root.querySelectorAll('.tag-chip'));
    var cards = Array.from(grid.querySelectorAll('.journal-card'));

    function applyFilter(filterTag) {
      var visibleCount = 0;

      cards.forEach(function(card) {
        var tagsAttr = card.getAttribute('data-tags') || '';
        var cardTags = tagsAttr.trim().split(/\s+/);
        var match = filterTag === 'all' || cardTags.indexOf(filterTag) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visibleCount += 1;
      });

      if (emptyMsg) {
        emptyMsg.hidden = visibleCount > 0;
      }
    }

    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        applyFilter(chip.getAttribute('data-filter'));
      });
    });
  }

  // Call init on DOMContentLoaded
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', init);

  // Copy-link button feature
  function initCopyLink() {
    var copyButtons = document.querySelectorAll('[data-copy-link]');

    copyButtons.forEach(function(btn) {
      // shopify:section:load fires this again — do not stack listeners.
      if (btn.dataset.copyLinkBound === 'true') return;
      btn.dataset.copyLinkBound = 'true';

      btn.addEventListener('click', function() {
        var url = btn.getAttribute('data-url');
        var originalLabel = btn.getAttribute('aria-label');
        var copiedLabel = btn.getAttribute('data-copied-label') || 'Link copied';

        var copyPromise = null;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          // writeText resolves with undefined, so normalise it to true —
          // otherwise the success branch below never runs.
          copyPromise = navigator.clipboard.writeText(url).then(function() {
            return true;
          }).catch(function() {
            return fallbackCopy(url);
          });
        } else {
          copyPromise = Promise.resolve(fallbackCopy(url));
        }

        copyPromise.then(function(success) {
          if (success) {
            btn.classList.add('is-copied');
            btn.setAttribute('aria-label', copiedLabel);

            setTimeout(function() {
              btn.classList.remove('is-copied');
              btn.setAttribute('aria-label', originalLabel);
            }, 2000);
          }
        }).catch(function() {
          // Silently fail — do not surface unhandled rejections
        });
      });
    });
  }

  function fallbackCopy(text) {
    try {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var success = document.execCommand('copy');
      document.body.removeChild(textarea);
      return success;
    } catch (err) {
      return false;
    }
  }

  // Init copy-link feature on load
  if (document.readyState !== 'loading') {
    initCopyLink();
  } else {
    document.addEventListener('DOMContentLoaded', initCopyLink);
  }

  // Re-init copy-link feature on section load
  document.addEventListener('shopify:section:load', initCopyLink);
})();
